/* eslint-disable import/prefer-default-export */

export function getVisxScaleModelForModel(model) {
  const nModel = {
    ...model,
    type: model.visxScaleType
  };
  delete nModel.visxScaleType;
  return nModel;
}